export default "__VITE_ASSET__DbIXCxRm__"